import { ActionTree } from 'vuex';
import getErrorMessage from '@/constants/messages/errors';
import { userAuthServiceApi } from './callers';
import { ADD_USER_ROLE_WITH_PERMISSIONS,
  DEL_USER_ROLE,
  FETCH_PERMISSIONS_FEATURES,
  FETCH_PERMISSIONS_OF_ROLE,
  FETCH_PERMISSIONS_ROLES,
  INotification,
  REINIT,
  RESET_PERMISSIONS_OF_ROLE,
  SET_ADDITION,
  SET_EDITION,
  SET_ERROR,
  SET_NOTIFICATION,
  SET_SELECTED,
  UPDATE_NAVIGATION,
  UPDATE_PERMISSIONS_FEATURES_OF_ROLE,
  UPDATE_PERMISSIONS_ROLES_LIST_STATE,
  USER_ROLES_LIST_NAVIGATION,
  UserRolesState } from './types';

const actions: ActionTree<UserRolesState, Record<string, never>> = {
  [SET_SELECTED]({ commit }, payload): void {
    commit(SET_SELECTED, payload);
  },
  [REINIT]({ commit }) {
    commit(REINIT);
  },
  [SET_ERROR]({ commit }, payload): void {
    commit(SET_ERROR, payload);
  },
  [USER_ROLES_LIST_NAVIGATION]({ commit }, payload): void {
    commit(USER_ROLES_LIST_NAVIGATION, payload);
  },
  [UPDATE_NAVIGATION]({ commit }, payload): void {
    commit(UPDATE_NAVIGATION, payload);
  },
  async [FETCH_PERMISSIONS_FEATURES]({ commit }): Promise<void> {
    return userAuthServiceApi.getPermissions()
      .then((res) => {
        commit(FETCH_PERMISSIONS_FEATURES, res);
      }).catch((e) => {
        commit(SET_NOTIFICATION, {
          content: FETCH_PERMISSIONS_FEATURES, status: `${e.status}`, isOpen: true
        });
      });
  },
  [RESET_PERMISSIONS_OF_ROLE]({ commit }): void {
    commit(RESET_PERMISSIONS_OF_ROLE);
  },
  async [FETCH_PERMISSIONS_ROLES]({ commit }, payload): Promise<void> {
    commit(UPDATE_PERMISSIONS_ROLES_LIST_STATE, {
      view: 'userRolesList',
      stateKey: 'loading',
      stateValue: true
    });

    const {
      elementsPerPage: size = 20,
      start = 0
    } = {
      ...payload
    };

    return userAuthServiceApi.listRoles(size, start)
      .then((res) => {
        commit(UPDATE_PERMISSIONS_ROLES_LIST_STATE, {
          view: 'userRolesList',
          stateKey: 'fetched',
          stateValue: true
        });

        commit(UPDATE_PERMISSIONS_ROLES_LIST_STATE, {
          view: 'userRolesList',
          stateKey: 'error',
          stateValue: false
        });
        commit(FETCH_PERMISSIONS_ROLES, res);
        commit(UPDATE_PERMISSIONS_ROLES_LIST_STATE, {
          view: 'userRolesList',
          stateKey: 'loading',
          stateValue: false
        });
      })
      .catch((e) => {
        commit(UPDATE_PERMISSIONS_ROLES_LIST_STATE, {
          view: 'userRolesList',
          stateKey: 'error',
          stateValue: true
        });

        commit(UPDATE_PERMISSIONS_ROLES_LIST_STATE, {
          view: 'userRolesList',
          stateKey: 'loading',
          stateValue: false
        });
        commit(SET_NOTIFICATION, {
          content: FETCH_PERMISSIONS_ROLES, status: `${e.status}`, isOpen: true
        });
      });
  },
  async [FETCH_PERMISSIONS_OF_ROLE]({ commit }): Promise<void> {
    return userAuthServiceApi.getRoleV2()
      .then((res) => {
        commit(FETCH_PERMISSIONS_OF_ROLE, res);
      }).catch((e) => {
        commit(SET_NOTIFICATION, {
          content: FETCH_PERMISSIONS_OF_ROLE, status: `${e.status}`, isOpen: true
        });
      });
  },
  async [UPDATE_PERMISSIONS_FEATURES_OF_ROLE]({ commit, dispatch }, payload): Promise<void> {
    return userAuthServiceApi.updateRole(payload)
      .then(() => {
        commit(UPDATE_PERMISSIONS_FEATURES_OF_ROLE, payload);
        commit(SET_NOTIFICATION, {
          content: 'Updated user role', status: '', isOpen: true, type: 'success'
        });
        dispatch(FETCH_PERMISSIONS_OF_ROLE, payload.id);
        commit(SET_EDITION, false);
        // return dispatch(FETCH_PERMISSIONS_ROLES);
      })
      .catch((err: Response) => {
        err.json().then((body) => {
          commit(SET_ERROR, getErrorMessage('userRoles', body.type));
        });
      });
  },
  [SET_EDITION]({ commit }, payload: boolean): void {
    commit(SET_EDITION, payload);
  },
  async [ADD_USER_ROLE_WITH_PERMISSIONS]({ commit, dispatch }, payload): Promise<void> {
    return userAuthServiceApi.createRole(payload)
      .then((res) => {
        commit(ADD_USER_ROLE_WITH_PERMISSIONS, res);
        commit(SET_NOTIFICATION, {
          content: 'New user role created', status: '', isOpen: true, type: 'success'
        });
        commit(SET_ADDITION, false);
        dispatch(FETCH_PERMISSIONS_ROLES);
      }).catch((e: Response) => {
        e.json().then((body) => {
          commit(SET_ERROR, getErrorMessage('userRoles', body.type));
        });
      });
  },
  async [DEL_USER_ROLE]({ commit, dispatch }, payload): Promise<void> {
    // tslint:disable-next-line: no-empty
    return userAuthServiceApi.deleteRole(payload)
      .then(() => {
        commit(SET_NOTIFICATION, {
          content: 'User role deleted', status: '', isOpen: true, type: 'success'
        });
        dispatch(FETCH_PERMISSIONS_ROLES);
      })
      .catch((err: Response) => {
        err.json().then((body) => {
          commit(SET_NOTIFICATION, {
            content: body.message, status: body.type, isOpen: true, type: 'error'
          });
        });
      });
  },
  [SET_NOTIFICATION]({ commit }, payload: INotification = {
    content: '', status: '', isOpen: false, type: ''
  }): void {
    commit(SET_NOTIFICATION, payload);
  },
  [SET_ADDITION]({ commit }, payload: boolean): void {
    commit(SET_ADDITION, payload);
  }
};

export default actions;
